// Expresiones del Camino: una distinta cada día (índice por día del año), con traducción EN/DE.
export const CAMINO_FRASES = [
  {
    frase: '¡Buen Camino!',
    significado: 'El saludo universal entre peregrinos. Se dice al cruzarse con alguien, al despedirse o al desear suerte.',
    en: { frase: 'Have a good Way!', significado: 'The universal pilgrim greeting, used when passing someone, saying goodbye or wishing luck.' },
    de: { frase: 'Guten Weg!', significado: 'Der universelle Pilgergruß: beim Begegnen, beim Abschied oder um Glück zu wünschen.' },
  },
  {
    frase: '¡Ultreia!',
    significado: 'Grito medieval de ánimo: «¡más allá, adelante!». Se responde «¡et suseia!» (¡y más arriba!).',
    en: { frase: 'Onward!', significado: 'Medieval cry of encouragement meaning "further, forward!". The reply is "et suseia!" (and higher!).' },
    de: { frase: 'Vorwärts!', significado: 'Mittelalterlicher Ermutigungsruf: „weiter, voran!“. Die Antwort lautet „et suseia!“ (und höher!).' },
  },
  {
    frase: 'Sellar la credencial',
    significado: 'Poner el sello en tu pasaporte de peregrino en albergues, iglesias o bares para demostrar tu recorrido.',
    en: { frase: 'To stamp the credential', significado: 'To get your pilgrim passport stamped at hostels, churches or bars as proof of your route.' },
    de: { frase: 'Den Pilgerpass stempeln', significado: 'In Herbergen, Kirchen oder Bars einen Stempel in den Pilgerpass bekommen, als Nachweis deiner Strecke.' },
  },
  {
    frase: 'Hacer una etapa',
    significado: 'Recorrer el tramo del día entre dos pueblos. «Hoy hago una etapa de 25 kilómetros».',
    en: { frase: 'To walk a stage', significado: 'To cover the day\'s stretch between two villages. "Today I\'m walking a 25 km stage."' },
    de: { frase: 'Eine Etappe gehen', significado: 'Die Tagesstrecke zwischen zwei Orten laufen. „Heute gehe ich eine Etappe von 25 Kilometern.“' },
  },
  {
    frase: 'Estar hecho polvo',
    significado: 'Estar agotadísimo. Lo normal al llegar al albergue después de subir O Cebreiro.',
    en: { frase: 'To be worn out', significado: 'To be completely exhausted. Normal when you reach the hostel after climbing O Cebreiro.' },
    de: { frase: 'Völlig fertig sein', significado: 'Total erschöpft sein. Ganz normal, wenn man nach dem Aufstieg zum O Cebreiro in der Herberge ankommt.' },
  },
  {
    frase: 'Tener ampollas',
    significado: 'Las heridas en los pies por el roce de las botas. Consejo: ¡vaselina y calcetines sin costuras!',
    en: { frase: 'To have blisters', significado: 'Sores on your feet from boots rubbing. Tip: Vaseline and seamless socks!' },
    de: { frase: 'Blasen haben', significado: 'Wunde Stellen an den Füßen durch reibende Schuhe. Tipp: Vaseline und nahtlose Socken!' },
  },
  {
    frase: '¿Queda mucho?',
    significado: 'La pregunta más repetida del Camino. La respuesta gallega suele ser «un poquito», que puede significar cualquier cosa.',
    en: { frase: 'Is it much further?', significado: 'The most repeated question on the Camino. The Galician answer is usually "just a little", which can mean anything.' },
    de: { frase: 'Ist es noch weit?', significado: 'Die meistgestellte Frage am Camino. Die galicische Antwort lautet meist „nur ein bisschen“ – und das kann alles bedeuten.' },
  },
  {
    frase: 'Poco a poco',
    significado: 'Sin prisa. La filosofía del Camino resumida en tres palabras.',
    en: { frase: 'Little by little', significado: 'No rush. The Camino philosophy in three words.' },
    de: { frase: 'Schritt für Schritt', significado: 'Ohne Eile. Die Philosophie des Camino in drei Worten.' },
  },
  {
    frase: 'La flecha amarilla',
    significado: 'La señal pintada que marca la ruta. Si la ves, vas bien; si no la ves en un rato, pregunta.',
    en: { frase: 'The yellow arrow', significado: 'The painted sign marking the route. If you see it, you\'re fine; if you haven\'t seen one for a while, ask.' },
    de: { frase: 'Der gelbe Pfeil', significado: 'Die gemalte Wegmarkierung. Siehst du ihn, ist alles gut; siehst du länger keinen, frag nach.' },
  },
  {
    frase: 'El mojón',
    significado: 'La piedra con la concha que indica los kilómetros que faltan hasta Santiago.',
    en: { frase: 'The waymarker', significado: 'The stone post with the shell showing how many kilometres remain to Santiago.' },
    de: { frase: 'Der Kilometerstein', significado: 'Der Stein mit der Muschel, der die verbleibenden Kilometer bis Santiago anzeigt.' },
  },
  {
    frase: 'El albergue está completo',
    significado: 'No quedan camas. Por eso muchos peregrinos madrugan tanto.',
    en: { frase: 'The hostel is full', significado: 'No beds left. That\'s why so many pilgrims set off so early.' },
    de: { frase: 'Die Herberge ist voll', significado: 'Keine Betten mehr frei. Deshalb stehen viele Pilger so früh auf.' },
  },
  {
    frase: 'Madrugar',
    significado: 'Levantarse muy temprano. En el Camino, a las 6 de la mañana ya suena el crujir de las mochilas.',
    en: { frase: 'To get up early', significado: 'To rise very early. On the Camino, backpacks are rustling by 6 a.m.' },
    de: { frase: 'Früh aufstehen', significado: 'Sehr früh aufstehen. Am Camino rascheln die Rucksäcke schon um 6 Uhr morgens.' },
  },
  {
    frase: 'El menú del peregrino',
    significado: 'Menú barato de tres platos con pan, vino y agua que ofrecen los restaurantes de la ruta.',
    en: { frase: 'The pilgrim\'s menu', significado: 'A cheap three-course meal with bread, wine and water offered by restaurants along the route.' },
    de: { frase: 'Das Pilgermenü', significado: 'Günstiges Drei-Gänge-Menü mit Brot, Wein und Wasser, das Restaurants am Weg anbieten.' },
  },
  {
    frase: '¡Que aproveche!',
    significado: 'Lo que se dice a quien está comiendo. Equivale a «bon appétit» o «guten Appetit».',
    en: { frase: 'Enjoy your meal!', significado: 'What you say to someone who is eating. The Spanish "bon appétit".' },
    de: { frase: 'Guten Appetit!', significado: 'Das sagt man jemandem, der gerade isst.' },
  },
  {
    frase: 'Un café con leche, por favor',
    significado: 'La frase que salva cada mañana. Con un «por favor» todo sabe mejor.',
    en: { frase: 'A coffee with milk, please', significado: 'The phrase that saves every morning. With a "please" everything tastes better.' },
    de: { frase: 'Einen Milchkaffee, bitte', significado: 'Der Satz, der jeden Morgen rettet. Mit einem „bitte“ schmeckt alles besser.' },
  },
  {
    frase: 'Tomar algo',
    significado: 'Beber o picar algo en un bar. «¿Tomamos algo en la plaza?» es una invitación a socializar.',
    en: { frase: 'To have a drink / a bite', significado: 'To drink or snack at a bar. "Shall we have something in the square?" is an invitation to socialise.' },
    de: { frase: 'Etwas trinken gehen', significado: 'In einer Bar etwas trinken oder essen. „Trinken wir was auf dem Platz?“ ist eine Einladung zum Plaudern.' },
  },
  {
    frase: 'Dar la lata',
    significado: 'Molestar o insistir. «Los ronquidos del albergue me dieron la lata toda la noche».',
    en: { frase: 'To be a pain', significado: 'To annoy or pester. "The snoring in the hostel was a pain all night."' },
    de: { frase: 'Nerven', significado: 'Stören oder lästig sein. „Das Schnarchen in der Herberge hat mich die ganze Nacht genervt.“' },
  },
  {
    frase: 'Echar una mano',
    significado: 'Ayudar. Los peregrinos siempre se echan una mano: una tirita, un mapa, una sonrisa.',
    en: { frase: 'To lend a hand', significado: 'To help. Pilgrims always lend each other a hand: a plaster, a map, a smile.' },
    de: { frase: 'Helfen / mit anpacken', significado: 'Pilger helfen sich immer gegenseitig: ein Pflaster, eine Karte, ein Lächeln.' },
  },
  {
    frase: 'Tirar la toalla',
    significado: 'Abandonar, rendirse. En el Camino casi nadie la tira: siempre hay un día mejor.',
    en: { frase: 'To throw in the towel', significado: 'To give up. Almost nobody does on the Camino: there is always a better day ahead.' },
    de: { frase: 'Das Handtuch werfen', significado: 'Aufgeben. Am Camino tut das fast niemand: Es kommt immer ein besserer Tag.' },
  },
  {
    frase: 'Hospitalero / hospitalera',
    significado: 'La persona que atiende el albergue, muchas veces voluntaria. Un «gracias» siempre es bienvenido.',
    en: { frase: 'Hostel host', significado: 'The person running the hostel, often a volunteer. A "gracias" is always welcome.' },
    de: { frase: 'Herbergsbetreuer/in', significado: 'Die Person, die die Herberge betreut, oft ehrenamtlich. Ein „gracias“ ist immer willkommen.' },
  },
  {
    frase: 'La Compostela',
    significado: 'El certificado en latín que recibes en Santiago tras caminar al menos los últimos 100 km.',
    en: { frase: 'The Compostela', significado: 'The Latin certificate you receive in Santiago after walking at least the last 100 km.' },
    de: { frase: 'Die Compostela', significado: 'Die lateinische Urkunde, die du in Santiago erhältst, wenn du mindestens die letzten 100 km gegangen bist.' },
  },
  {
    frase: 'El botafumeiro',
    significado: 'El enorme incensario de la catedral de Santiago. Verlo volar es el broche final del Camino.',
    en: { frase: 'The botafumeiro', significado: 'The giant incense burner in Santiago cathedral. Watching it swing is the grand finale of the Camino.' },
    de: { frase: 'Der Botafumeiro', significado: 'Das riesige Weihrauchfass der Kathedrale von Santiago. Es schwingen zu sehen ist der krönende Abschluss.' },
  },
  {
    frase: 'Abrazar al Apóstol',
    significado: 'La tradición de abrazar la estatua de Santiago detrás del altar mayor de la catedral.',
    en: { frase: 'To hug the Apostle', significado: 'The tradition of embracing the statue of St James behind the cathedral\'s main altar.' },
    de: { frase: 'Den Apostel umarmen', significado: 'Die Tradition, die Statue des heiligen Jakobus hinter dem Hauptaltar der Kathedrale zu umarmen.' },
  },
  {
    frase: 'Estar en el quinto pino',
    significado: 'Estar muy lejos. «El albergue está en el quinto pino» = todavía te queda un buen rato.',
    en: { frase: 'To be in the middle of nowhere', significado: 'To be very far away. "The hostel is in the middle of nowhere" = you still have a good while to go.' },
    de: { frase: 'Am Ende der Welt sein', significado: 'Sehr weit weg sein. „Die Herberge ist am Ende der Welt“ = du hast noch ein gutes Stück vor dir.' },
  },
  {
    frase: 'Ir a tu ritmo',
    significado: 'Caminar a tu propia velocidad, sin compararte con nadie. El mejor consejo del Camino.',
    en: { frase: 'To go at your own pace', significado: 'To walk at your own speed without comparing yourself to anyone. The best Camino advice.' },
    de: { frase: 'In deinem eigenen Tempo gehen', significado: 'In deiner eigenen Geschwindigkeit laufen, ohne dich mit anderen zu vergleichen. Der beste Rat am Camino.' },
  },
  {
    frase: 'Llevar la mochila a cuestas',
    significado: 'Cargar la mochila en la espalda. También se usa para hablar de las preocupaciones que uno lleva.',
    en: { frase: 'To carry the backpack on your back', significado: 'Literally carrying your pack; also used for the worries one carries around.' },
    de: { frase: 'Den Rucksack auf dem Rücken tragen', significado: 'Wörtlich den Rucksack tragen; auch für die Sorgen, die man mit sich herumträgt.' },
  },
  {
    frase: 'Un chubasco',
    significado: 'Lluvia repentina y fuerte. En Galicia conviene tener siempre el chubasquero a mano.',
    en: { frase: 'A downpour', significado: 'Sudden heavy rain. In Galicia, keep your rain jacket within reach.' },
    de: { frase: 'Ein Regenschauer', significado: 'Plötzlicher, starker Regen. In Galicien sollte die Regenjacke immer griffbereit sein.' },
  },
  {
    frase: 'Orballo',
    significado: 'Palabra gallega para la lluvia fina y persistente. No moja... hasta que te empapa.',
    en: { frase: 'Drizzle (Galician)', significado: 'Galician word for fine, persistent rain. It doesn\'t wet you... until you\'re soaked.' },
    de: { frase: 'Nieselregen (galicisch)', significado: 'Galicisches Wort für feinen, anhaltenden Regen. Macht nicht nass... bis man durchnässt ist.' },
  },
  {
    frase: 'Descansar un rato',
    significado: 'Parar un momento para recuperar fuerzas. Quítate las botas y deja respirar los pies.',
    en: { frase: 'To rest a while', significado: 'To stop for a moment and recover. Take off your boots and let your feet breathe.' },
    de: { frase: 'Eine Weile ausruhen', significado: 'Kurz anhalten und Kraft schöpfen. Schuhe aus und die Füße atmen lassen.' },
  },
  {
    frase: '¡Ánimo!',
    significado: 'Palabra para dar fuerzas a alguien. La escucharás en cada cuesta del Camino.',
    en: { frase: 'Come on, you can do it!', significado: 'A word of encouragement. You\'ll hear it on every climb of the Camino.' },
    de: { frase: 'Kopf hoch! / Du schaffst das!', significado: 'Ein Wort der Ermutigung. Du hörst es an jedem Anstieg des Camino.' },
  },
  {
    frase: 'Merece la pena',
    significado: 'Vale el esfuerzo. Como ver el amanecer desde el Alto del Perdón.',
    en: { frase: 'It\'s worth it', significado: 'Worth the effort. Like watching the sunrise from Alto del Perdón.' },
    de: { frase: 'Es lohnt sich', significado: 'Die Mühe wert. Wie der Sonnenaufgang vom Alto del Perdón.' },
  },
];

export const fraseDelDia = (date = new Date()) => {
  const start = new Date(date.getFullYear(), 0, 0);
  const day = Math.floor((date - start) / 86400000);
  return CAMINO_FRASES[day % CAMINO_FRASES.length];
};
